import { translations } from '../i18n/translations';
import { availableLanguages } from '../constants/availableLanguages';

export function getUserLanguage() {
  const langFromLocalStorage = localStorage.getItem('interfaceLanguageRealistSecurityHub');

  if (langFromLocalStorage) {
    const isAvailableLanguagesIncludesLangFromLocalStorage = availableLanguages.includes(localStorage.getItem('interfaceLanguageRealistSecurityHub')!.toLowerCase());

    if (isAvailableLanguagesIncludesLangFromLocalStorage && Object.keys(translations).includes(langFromLocalStorage)) {
      return langFromLocalStorage;
    }
  }

  const availableLanguageFromNavigator = navigator.languages.find((lang) => availableLanguages.find((item) => item === lang.slice(0, 2).toLowerCase()))?.slice(0, 2).toLowerCase();

  return availableLanguageFromNavigator && Object.keys(translations).includes(availableLanguageFromNavigator) ? availableLanguageFromNavigator : 'uk';
}
